// extracted by mini-css-extract-plugin
export default {"top":"Tables_top_xjsnz"};